// extracted by mini-css-extract-plugin
module.exports = {"box":"BoardListItem_box__318Xz"};